import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { parse, format } from 'date-fns';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, DateTime } from '~/components/Form';
import { t } from '~/helpers';
import { compareIsAfterDates } from '~/helpers/dateTime';
import { validation, validationErrors } from '~/helpers/yupValidations';
import { updateData } from '~/store/modules/EdicaoOperacao/Turno/actions';

import { Accounting, Closing } from '..';

import * as S from './styles';

export default function Form({ reference, data }) {
  const { loading, find, params } = useSelector((state) => state.turno);

  const dispatch = useDispatch();
  const initials = { ...find, ...data };

  const handleSubmit = useCallback(
    async (formData) => {
      try {
        const schema = Yup.object().shape({
          datahorainicialturno: Yup.mixed()
            .transform((value) =>
              value ? parse(value, 'dd/MM/yyyy HH:mm:ss', new Date()) : null
            )
            .required(t('s.geral.validacao.campoobrigatorio'))
            .test(
              'datahorainicialturno',
              t('s.servidor.turno.dataaberturasuperiordataatual'),
              () =>
                !compareIsAfterDates({
                  compare: formData.datahorafinalturno,
                  current: formData.datahorainicialturno,
                })
            ),
          datahorafinalturno: Yup.mixed()
            .transform((value) =>
              value ? parse(value, 'dd/MM/yyyy HH:mm:ss', new Date()) : null
            )
            .required(t('s.geral.validacao.campoobrigatorio'))
            .test(
              'datahorainicialturno',
              t(
                's.servidor.turno.datahorafechamentodevesersuperiordataabertura'
              ),
              () =>
                compareIsAfterDates({
                  compare: formData.datahorafinalturno,
                  current: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
                })
            ),
        });

        await validation(schema, formData);

        dispatch(updateData(Object.assign(initials, formData), params));
      } catch (error) {
        validationErrors(error, reference);
      }
    },
    [initials, params]
  );

  if (loading)
    return (
      <div style={{ height: '14rem', width: '50rem' }}>
        <Spinner loading />
      </div>
    );

  return (
    <S.Wrapper ref={reference} initialData={initials} onSubmit={handleSubmit}>
      <Input disabled name="idturno" label={t('s.relatorio.geral.unidade')} />
      <S.GroupInput>
        <DateTime
          time
          name="datahorainicialturno"
          label={t('s.operacao.turno.abertura')}
        />

        <Input
          name="observacaoinicioturno"
          label={t('s.operacao.turno.observacao')}
        />
      </S.GroupInput>
      <S.GroupInput>
        <DateTime
          time
          name="datahorafinalturno"
          label={t('s.operacao.turno.fechamento')}
        />

        <Input
          name="observacaofimturno"
          label={t('s.operacao.turno.observacao')}
        />
      </S.GroupInput>

      <Closing editable data={initials.bicos ?? []} />

      <Accounting editable data={initials.tanques ?? []} />
    </S.Wrapper>
  );
}

Form.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

Form.defaultProps = {
  data: {},
};
